/**
 * Created by andrey on 25.08.2022.
 */

const PassTicket = cc.Node.extend({
    ctor: function (options) {
        this.premium = options.premium;
        this.passLogic = options.passLogic;

        this._super();

        const styles = cleverapps.styles.PassTicket;

        this.setContentSize2(styles.width, styles.height);
        this.setAnchorPoint(0.5, 0.5);

        if (bundles.passtickets.frames.ticket_background) {
            const background = cleverapps.UI.createScale9Sprite(bundles.passtickets.frames.ticket_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
            background.setContentSize2(styles.width, styles.height);
            background.setAlignment(styles.width / 2, styles.height / 2);
            this.addChild(background);
        }

        if (bundles.passtickets.frames.order_rings) {
            styles.rings.forEach(function (position) {
                const ring = new cc.Sprite(bundles.passtickets.frames.order_rings);
                ring.setAlignment(position);
                this.addChild(ring);
            }, this);
        }

        const titleSize = this.premium && styles.premium.text || styles.text;
        const title = cleverapps.UI.generateOnlyText(
            Messages.get(this.premium ? "PassWindow.ticket.hint" : "PassWindow.ticket.freeHint"),
            this.premium ? cleverapps.styles.FONTS.PASS_TICKET_TEXT : cleverapps.styles.FONTS.PASS_TICKET_SMALL_TEXT
        );
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setVerticalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.fitTo(titleSize.width, titleSize.height);
        const iconNode = new cleverapps.Spine(this.passLogic.getTicketJson());
        iconNode.setAnchorPoint(0.5, 0.5);
        iconNode.setAnimation(0, this.premium ? "animation" : "animation2", true);

        let buyTicketButton, checkmark;

        if (this.premium && !this.passLogic.hasPremium()) {
            buyTicketButton = this.createTicketButton();

            cleverapps.UI.onClick(iconNode, () => {
                if (this.passLogic.canBuyPremium()) {
                    cleverapps.focusManager.display({
                        focus: "PassBuyTicketWindow",
                        stack: true,
                        action: (f) => {
                            new PassBuyTicketWindow(this.passLogic);
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                }
            });
        } else {
            checkmark = new cc.Sprite(bundles.passtickets.frames.pass_attention_png);
            if (styles.checkmark) {
                checkmark.setAlignment(styles.checkmark);
            }
        }

        let items = [title, iconNode, buyTicketButton, checkmark];
        if (cleverapps.config.ui === "tropical") {
            items = [buyTicketButton, title, iconNode];
            checkmark && iconNode.addChild(checkmark);
        }
        const itemsLayout = new cleverapps.Layout(items, {
            margin: (this.premium && styles.premium.margin) ? styles.premium.margin : styles.margin,
            direction: cleverapps.UI.VERTICAL,
            dimensions: styles
        });
        itemsLayout.setAlignment(this.premium ? styles.premium : styles.free);
        this.addChild(itemsLayout);

        if (this.premium && styles.premium.icon) {
            iconNode.setAlignment(styles.premium.icon);
        }

        if (!this.premium && styles.free.icon) {
            iconNode.setAlignment(styles.free.icon);
        }

        cleverapps.paymentsLogic.onChangeStatus(this.updateButton.bind(this), this);
    },

    createTicketButton: function () {
        const styles = cleverapps.styles.PassTicket.button;

        if (this.passLogic.hasPremium()) {
            return new cc.Sprite(bundles.passtickets.frames.pass_attention_png);
        }

        this.button = new cleverapps.UI.Button({
            text: this.passLogic.getPriceText(),
            type: cleverapps.styles.UI.Button.Images.small_button_green,
            width: styles.width,
            height: styles.height,
            disabled: !this.passLogic.canBuyPremium(),
            onClicked: this.passLogic.buyPremium.bind(this.passLogic)
        });

        this.passLogic.onPremiumPurchaseFailedListeners.passTicket = this.createListener(this.updateButton.bind(this));

        this.updateButton();
        return this.button;
    },

    updateButton: function () {
        if (this.button) {
            this.button.setString(this.passLogic.getPriceText());

            if (this.passLogic.getProduct().isAvailable()) {
                this.button.enable();
            } else {
                this.button.disable();
            }
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PASS_TICKET_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    PASS_TICKET_SMALL_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.PassTicket = {
    width: 300,
    height: 300,
    margin: 5,

    text: {
        width: 240,
        height: 70
    },

    free: {
        x: { align: "center", dx: 15 },
        y: { align: "center", dy: 22 },
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -50 }
        }
    },

    premium: {
        x: { align: "center", dx: 15 },
        y: { align: "bottom", dy: 12 },
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 36 }
        }
    },

    icon: {
        width: 160,
        height: 220
    },

    button: {
        width: 170,
        height: 60,
        scale: 1.2
    }
};
